<template>
  <v-slide-y-transition mode="out-in">
    <v-container fluid class="pa-3">
      <v-layout row wrap>
        <v-flex>
          <v-card>
            <v-toolbar dense prominent>
              <v-toolbar-title>Employee Activity</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-toolbar-items> </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pa-0">
              <v-container>
                <v-layout row wrap>
                  <v-expansion-panel>
                    <v-expansion-panel-content>
                      <template v-slot:header>
                        <div class="subheading">
                          Filter Panel
                        </div>
                      </template>

                      <v-btn color="green" @click="refresh_table()"
                        >Generate Now</v-btn
                      >

                      <FilterEditor
                        :query.sync="new_filter"
                        :rules="get_filterable_columns"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table
                      id="report_table"
                      :headers="table_setting.headers"
                      :items="table_setting.records"
                      :loading="table_setting.loading"
                      must-sort
                      :pagination.sync="table_setting.pagination"
                      :rows-per-page-items="table_setting.rows_per_page_items"
                      :total-items="table_setting.pagination.totalItems"
                      class="elevation-1"
                    >
                      <v-progress-linear
                        v-slot:progress
                        color="blue"
                        indeterminate
                      ></v-progress-linear>
                      <template v-slot:items="props">
                        <td class="pa-1 pl-3">{{ props.item.id }}</td>
                        <td class="pa-1">{{ props.item.date }}</td>
                        <td class="pa-1">
                          {{ get_date_day(props.item.date) }}
                        </td>
                        <td class="pa-1">{{ props.item.emp__full_name }}</td>
                        <td class="pa-1">{{ props.item.device__name }}</td>
                        <td class="pa-1">
                          {{
                            props.item.emp__dept_employee__dept__company__name
                          }}
                        </td>
                        <td class="pa-1">
                          {{ props.item.emp__dept_employee__dept__name }}
                        </td>
                        <td class="pa-1">{{ props.item.event__value }}</td>
                        <td class="pa-1">
                          {{ get_epoch_time(props.item.time) }}
                        </td>
                        <td class="pa-1">
                          <img
                            :src="props.item.image_full_path"
                            style="width:70px;"
                          />
                        </td>
                      </template>
                    </v-data-table>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
import common from "../../functions/general";
import qb from "../../functions/query.builder";
import FilterEditor from "../../components/FilterEditor";

const day_setting = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default {
  name: "EmpRawActivities",
  components: {
    FilterEditor: FilterEditor
  },
  data() {
    return {
      new_filter: {
        condition: "and",
        rules: []
      },
      filter_options: [],
      table_setting: {
        loading: false,
        rows_per_page_items: [
          10,
          40,
          70,
          100,
          200,
          500,
          1000,
          1500,
          2000,
          2500,
          3000
        ],
        headers: [
          {
            text: "ID#",
            value: "id",
            class: "pa-1 pl-3",
            filterable: true,
            data_type: Number
          },
          {
            text: "Date",
            class: "pa-1",
            value: "date",
            filterable: true,
            data_type: Number
          },
          {
            text: "Day",
            value: "dk",
            class: "pa-1",
            sortable: false,
            filterable: false,
            data_type: String
          },
          {
            text: "Name",
            align: "left",
            class: "pa-1",
            value: "emp__full_name",
            filterable: true,
            data_type: String
          },
          {
            text: "Device Name",
            class: "pa-1",
            value: "device__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Company",
            class: "pa-1",
            value: "emp__dept_employee__dept__company__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Dept",
            class: "pa-1",
            value: "emp__dept_employee__dept__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Type of Event",
            class: "pa-1",
            value: "event__value",
            filterable: true,
            data_type: String
          },
          {
            text: "Time",
            class: "pa-1",
            value: "time",
            filterable: true,
            data_type: String
          },
          {
            text: "Image ID",
            class: "pa-1",
            value: "iamge_id",
            filterable: true,
            data_type: String
          }
        ],
        records: [],
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 10,
          sortBy: "id",
          totalItems: 0
        }
      }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "table_setting.pagination": {
      handler: function() {
        this.refresh_table();
      },
      deep: true
    }
  },
  async mounted() {},
  methods: {
    get_epoch_time(epoch) {
      var return_value = "";

      if (epoch) {
        return_value = new Date(epoch * 1000).toTimeString().split(" ")[0];
      }

      return return_value;
    },
    async get_image_full_path(date, image_id) {
      var date_arr = date.split("-");
      var file = `https://mindattendance.lms.solutions/${date_arr[0]}/${date_arr[1]}/${date_arr[2]}/${image_id}`;

      // let result = await common.wBackEndComm.GetData(
      //   "get_activity_image/?file=" + file
      // );
      // return "data:image/jpeg;base64," + result.data.Body;

      return file;
    },
    get_date_day(date) {
      return day_setting[new Date(date).getDay()];
    },
    async refresh_table() {
      this.table_setting.loading = true;
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = [
        "id",
        "emp__full_name",
        "emp__dept_employee__dept__name",
        "emp__dept_employee__dept__company__name",
        "date",
        "device__name",
        "time",
        "event__value",
        "image_id"
      ];

      //   var rule = new qb.Rule();

      //   rule
      //     .field("dept_id")
      //     .operator(qb.NUM_OPERATOR.EQUAL)
      //     .value(dept_id);

      cls_qb.Where = this.new_filter;

      //   cls_qb.Where = {
      //     condition: "and",
      //     rules: [
      //       {
      //         field: "date",
      //         operator: "__gt",
      //         value: "2019-09-03"
      //       },
      //       {
      //         condition: "or",
      //         rules: [
      //           {
      //             field: "lunch_lateness",
      //             operator: "__gte",
      //             value: "0"
      //           },
      //           {
      //             field: "early",
      //             operator: "__gte",
      //             value: "0"
      //           }
      //         ]
      //       }
      //     ]
      //   };

      if (this.table_setting.pagination.rowsPerPage > 0) {
        cls_qb.Offset =
          (this.table_setting.pagination.page - 1) *
          this.table_setting.pagination.rowsPerPage;
        cls_qb.Limit = this.table_setting.pagination.rowsPerPage;
      }

      cls_qb.Order = [
        this.table_setting.pagination.descending
          ? "-" + this.table_setting.pagination.sortBy
          : this.table_setting.pagination.sortBy
      ];

      let result = await common.wBackEndComm.PostData(
        "activity/listing/",
        cls_qb
      );

      if (result.data.Status == 1) {
        for (
          let index = 0, m = result.data.Body.records.length;
          index < m;
          index++
        ) {
          const element = result.data.Body.records[index];

          element["image_full_path"] = await this.get_image_full_path(
            element.date,
            element.image_id
          );
        }
        this.table_setting.records = result.data.Body.records;

        this.table_setting.pagination.totalItems =
          result.data.Body.total_records_after_filtered;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }

      this.table_setting.loading = false;
    }
  }
};
</script>

<style>
</style>
